import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig, loginRequest } from "../config/authConfig";

const RedirectPage = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const msalInstance = new PublicClientApplication(msalConfig);
  const [accessToken, setAccessToken] = useState<string | null>(null);

  useEffect(() => {
    const init = async () => {
      await msalInstance.initialize(); // ✅ Initialize MSAL

      msalInstance.handleRedirectPromise()
        .then(async (response) => {
          if (response) {
            const account = response.account;
            if (account) {
              msalInstance.setActiveAccount(account);

              // Get access token silently
              const tokenResponse = await msalInstance.acquireTokenSilent({
                ...loginRequest,
                account: account,
              });

              setAccessToken(tokenResponse.accessToken);

              // ✅ Redirect after successful login
              navigate("/5cf53127-c224-4731-bab0-0e4464636b15");
            }
          } else {
            // If no response (first time), maybe redirect to login again or show something
            // console.log("No auth response found.");
          }
        })
        .catch((error) => {
          console.error("Auth error", error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    };

    init();
  }, [navigate]);

  return (
    <div className="redirect-page">
      {isLoading ? (
        <div className="loading">
          <h2>Processing authentication...</h2>
        </div>
      ) : (
        <div>
          <h2>Dashboard {accessToken} </h2>
          <p>Authentication complete. Redirecting...</p>
        </div>
      )}
    </div>
  );
};

export default RedirectPage;
